const spacing = [4, 8];
export default spacing;
